export default __webpack_public_path__ + "static/media/Background_00265.da5e6f62.png";